var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsblogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.276,
    height: 200,
    viewBox: "0 0 203.276 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-0.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(0.095 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logomark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    d: "M71.123,31.643A31.631,31.631,0,1,1,39.493,0,31.637,31.637,0,0,1,71.123,31.643",
    transform: "translate(8.643)",
    fill: "#3462a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M18.586,28.957l38.68,38.7-.011.01.011.011-38.68,38.695L0,87.775,20.1,67.662,0,47.55Z",
    transform: "translate(0 31.837)",
    fill: "#d44028",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M87.138,10.257,105.724,28.85,64.381,70.21l20.1,20.112L65.9,108.915,27.219,70.221h0l-.01-.01Z",
    transform: "translate(29.915 11.277)",
    fill: "#d44028",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logotype",
    transform: "translate(40.953 131.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M12.089,10.711,9.467,3.4H8.554L5.932,10.711Zm5.932,6.054H14.259l-.985-2.748H4.747l-.985,2.748H0L5.971.107H12.05Z",
    transform: "translate(0 0.117)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M17.79,7.582l6.78,9.192H20.026l-4.782-6.389-2.537,2.792v3.6H9.077V.1h3.63V7.755L19.691.116H24.57Z",
    transform: "translate(9.98 0.109)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M29.027,10.711,26.405,3.4h-.913L22.87,10.711Zm5.932,6.054H31.2l-.985-2.748H21.685L20.7,16.765H16.938L22.909.107h6.08Z",
    transform: "translate(18.623 0.117)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M15.864,23.95c0,4.139-2.76,5.18-7.64,5.18C0,29.129,0,24.577,0,22.964H3.724c0,2.518,2.217,2.912,4.385,2.912,2.744,0,3.886-.632,3.886-1.924,0-1.135-1.14-1.331-4.412-1.814C2.595,21.4.353,20.37.353,17.32c0-2.354,1.745-5.073,7.191-5.073,6.481,0,7.773,3.623,7.773,6.163H11.509c0-1.156-.514-2.874-3.965-2.874-2.812,0-3.45,1.013-3.45,1.818,0,.884.983,1.215,3.774,1.668,3.741.607,8,1.157,8,4.929",
    transform: "translate(0 13.465)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M8.319,29.021H11.95V12.346H8.319Z",
    transform: "translate(9.147 13.574)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M23.952,12.346h3.631V29.021H22.354L15.038,17.055h-.417V29.021H10.99V12.346H15.9v.017h.322l7.306,11.948h.427Z",
    transform: "translate(12.083 13.574)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M36.748,19.483v9.545H33.118v-2.6h-.2a4.667,4.667,0,0,1-4.632,2.734c-4.791,0-8.675-2.891-8.675-8.473,0-5.479,3.884-8.473,8.675-8.473,4.329,0,7.711,2.414,8.352,5.607H32.668c-.692-1.286-2.094-1.909-4.384-1.909-2.853,0-5.053,1.463-5.053,4.775s2.2,4.775,5.053,4.775c2.753,0,4.175-.977,4.655-2.579H28.174v-3.4Z",
    transform: "translate(21.56 13.432)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M11.36,36.135c0-1.572-1-1.829-2.674-1.829H3.63v3.656h4.6c1.77,0,3.133-.114,3.134-1.827ZM3.629,27.9v3.5H7.611c1.677,0,3.043-.063,3.043-1.749,0-1.649-1.428-1.749-3.2-1.749Zm11.287,8.627a4.4,4.4,0,0,1-4.688,4.742H0V24.593H8.493c3.474,0,5.719,1.394,5.719,4.742,0,1.821-.58,2.826-1.628,3.382,1.489.527,2.332,1.614,2.333,3.809Z",
    transform: "translate(0 27.038)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    d: "M19.385,35.2l-2.622-7.316H15.85L13.228,35.2Zm5.932,6.054H21.555L20.57,38.51H12.043l-.985,2.748H7.3L13.267,24.6h6.079Z",
    transform: "translate(8.021 27.047)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M31.851,36.2c0,4.139-2.76,5.18-7.64,5.18-8.226,0-8.224-4.552-8.224-6.166h3.724c0,2.518,2.217,2.912,4.385,2.912,2.744,0,3.886-.632,3.886-1.924,0-1.135-1.14-1.331-4.412-1.814-4.989-.735-7.231-1.768-7.231-4.819,0-2.354,1.745-5.073,7.191-5.073,6.481,0,7.773,3.623,7.773,6.163H27.5c0-1.156-.514-2.874-3.965-2.874-2.812,0-3.45,1.013-3.45,1.818,0,.884.983,1.215,3.774,1.668,3.741.607,8,1.157,8,4.929",
    transform: "translate(17.577 26.93)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M33,32.076l6.78,9.192H35.239l-4.782-6.389L27.92,37.671v3.6H24.29V24.593h3.63v7.656L34.9,24.609h4.879Z",
    transform: "translate(26.705 27.038)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M38.977.1h3.631V16.774H37.379L30.062,4.808h-.417V16.774H26.015V.1h4.906V.116h.323l7.306,11.948h.427Z",
    transform: "translate(28.602 0.109)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M43.591,7.582l6.781,9.192H45.828l-4.782-6.389-2.537,2.792v3.6h-3.63V.1h3.63V7.755L45.493.116h4.879Z",
    transform: "translate(38.347 0.109)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M58.054,11.7c0,4.139-2.76,5.18-7.64,5.18-8.226,0-8.224-4.552-8.224-6.166h3.724c0,2.518,2.217,2.912,4.385,2.912,2.744,0,3.886-.632,3.886-1.924,0-1.135-1.14-1.331-4.412-1.814-4.989-.735-7.231-1.768-7.231-4.819C42.543,2.719,44.287,0,49.734,0c6.481,0,7.773,3.623,7.773,6.163H53.7c0-1.156-.514-2.874-3.965-2.874-2.812,0-3.45,1.013-3.45,1.818,0,.884.983,1.215,3.774,1.668,3.741.607,8,1.157,8,4.929",
    transform: "translate(46.386 0)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M62.843.1h3.631V16.774H62.843v-6.7h-8.72v6.7h-3.63V.1h3.63V6.8h8.72Z",
    transform: "translate(55.513 0.109)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M70.681,10.711,68.059,3.4h-.913l-2.622,7.316Zm5.932,6.054H72.851l-.985-2.748H63.339l-.985,2.748H58.592L64.562.107h6.08Z",
    transform: "translate(64.419 0.117)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M41.046,12.346h3.631V29.021H41.046v-6.7h-8.72v6.7H28.7V12.346h3.63v6.7h8.72Z",
    transform: "translate(31.549 13.574)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M45.87,24.592V27.87H35.781v3.423H45.87v3.276H35.781V37.95H45.87v3.318H32.151V24.592Z",
    transform: "translate(35.349 27.038)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M39.171,24.593H55.416V27.9H49.109V41.268H45.478V27.9H39.171Z",
    transform: "translate(43.067 27.038)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M58.749,36.135c0-1.572-1-1.829-2.674-1.829H51.02v3.656h4.6c1.77,0,3.133-.114,3.134-1.827ZM51.02,27.9v3.5H55c1.677,0,3.043-.063,3.043-1.749,0-1.649-1.428-1.749-3.2-1.749Zm11.287,8.627a4.4,4.4,0,0,1-4.688,4.742H47.39V24.593h8.492c3.473,0,5.719,1.394,5.719,4.742,0,1.821-.58,2.826-1.628,3.382,1.489.527,2.332,1.614,2.333,3.809Z",
    transform: "translate(52.103 27.038)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    d: "M66.775,35.2l-2.622-7.316H63.24L60.618,35.2Zm5.932,6.054H68.945L67.96,38.51H59.433l-.985,2.748H54.686L60.657,24.6h6.08Z",
    transform: "translate(60.125 27.047)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M67.393,37.991H77.481v3.276H63.763V24.593h3.631Z",
    transform: "translate(70.104 27.039)",
    fill: "#1c1610",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    d: "M74.413,37.991H84.5v3.276H70.782V24.593h3.631Z",
    transform: "translate(77.822 27.039)",
    fill: "#1c1610",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsblogo);
export default __webpack_public_path__ + "static/media/ASBLOGO.c81846cafa1b61cee9db467f60237daa.svg";
export { ForwardRef as ReactComponent };